import './ExpiredWarning.css';
import { Close, LogoIconWhite } from '../../services/Assets.js';
import { useTranslation } from 'react-i18next';
import '../../i18n'

const ExpiredWarning = ({ closeModal }) => {
  const { t } = useTranslation();

  return (
    <div className="modal fade show" id="upgradeModal" aria-modal="true" role="dialog" style={{ display: 'block' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header pos-header">
            <img src={LogoIconWhite} className="modal-img" alt="image"></img>
            <img src={Close} className="closeBtn" onClick={closeModal} style={{cursor: "pointer" }}></img>
          </div>
          <div className="modal-body text-center">
            <h2 className="text-dark"><i className="fa fa-info-circle m-2"></i>{t('Paused')}</h2>
            <p className="mb-0 fw-400 text-center">{t('Please choose a plan to continue')}</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-upgrade" onClick={()=> window.open("https://getqroq.in" , "_blank")}>{t('Click to Get Your Plan')}<i className="fa-solid fa-arrow-right m-2"></i></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpiredWarning;